import { useQuery } from "@tanstack/react-query";
import { validate } from "uuid";
import { getPaymentType, getPaymentTypes } from "../api";

export const usePaymentTypes = (filters = {}) =>
	useQuery({
		queryFn: () => getPaymentTypes(filters),
		queryKey: ["paymentTypes", filters],
	});

export const usePaymentType = (id?: string) =>
	useQuery({
		queryFn: () => getPaymentType(id),
		enabled: validate(id),
		queryKey: ["paymentTypes", { id }],
	});
